module.exports = __webpack_public_path__ + "img/editInsert.fd4edc88.svg";